import React from 'react';
import { Box, Stack } from '@mui/material';
import AlbumPrimaryActions from './AlbumPrimaryActions';
import StarButton from '../../../../components/button/StarButton';
import HomeAlbumFeatureButton from '../../../../components/button/HomeAlbumFeatureButton';
import RecommendedAlbumCommentButton from '../../../../components/button/RecommendedAlbumCommentButton';
import LatestAlbumManagementButton from '../../../../components/button/LatestAlbumManagementButton';

const AlbumInfoSection = ({
  albumInfo,
  actionRef,
  reviews,
  bookmarkPending,
  onBookmarkToggle,
  pageType,
  headerOptions,
}) => {
  if (!albumInfo) {
    return null;
  }

  return (
    <Box>
      <AlbumPrimaryActions
        ref={actionRef}
        headerOptions={headerOptions}
        album={albumInfo}
        reviews={reviews}
        bookmarkPending={bookmarkPending}
        onBookmarkToggle={onBookmarkToggle}
        pageType={pageType}
      />
    </Box>
  );
};

export default AlbumInfoSection;

export function AlbumAdminActions({
  albumInfo,
  isAdmin,
  onStarredToggle,
  onHomeLatestToggle,
  onHomeRecommendedToggle,
  onRecommendedCommentUpdate,
  onLatestAlbumRegionMove,
  onLatestAlbumHide,
  onLatestAlbumRegister,
  onRecommendedAlbumRemove,
}) {
  if (!albumInfo || !isAdmin) return null;
  return (
    <Stack
      className="pp-album-admin-actions"
      aria-label="앨범 관리"
      direction="row"
      useFlexGap
      flexWrap="wrap"
      spacing={1}
      alignItems="center"
    >
      {isAdmin && <StarButton isStarred={albumInfo.isStarred} onToggle={onStarredToggle} />}
      {isAdmin && (
        <HomeAlbumFeatureButton
          albumInfo={albumInfo}
          onToggleLatest={onHomeLatestToggle}
          onToggleRecommended={onHomeRecommendedToggle}
        />
      )}
      {isAdmin && (
        <RecommendedAlbumCommentButton
          albumInfo={albumInfo}
          onUpdate={onRecommendedCommentUpdate}
        />
      )}
      {isAdmin && (
        <LatestAlbumManagementButton
          albumInfo={albumInfo}
          onMoveRegion={onLatestAlbumRegionMove}
          onHide={onLatestAlbumHide}
          onRegister={onLatestAlbumRegister}
          onRemoveRecommended={onRecommendedAlbumRemove}
        />
      )}
    </Stack>
  );
}
